import { Link } from 'react-router-dom'
import './AboutFour.css'

function AboutFour() {
   return (
      <div className="about-area position-relative space" id="about-sec">
         <div className="container">
            <div className="row align-items-center">
               <div className="col-lg-6 mb-4 mb-lg-0">
                  <div className="about-animation-container">
                     <div className="animation-background">
                        <div className="floating-icon icon-1">
                           <i className="fas fa-broadcast-tower"></i>
                        </div>
                        <div className="floating-icon icon-2">
                           <i className="fas fa-wifi"></i>
                        </div>
                        <div className="floating-icon icon-3">
                           <i className="fas fa-map-marked-alt"></i>
                        </div>
                        <div className="floating-icon icon-4">
                           <i className="fas fa-chart-bar"></i>
                        </div>
                        <div className="floating-icon icon-5">
                           <i className="fas fa-mobile-alt"></i>
                        </div>
                        <div className="central-icon">
                           <i className="fas fa-globe-americas"></i>
                        </div>
                     </div>
                     <div className="animation-particles">
                        <div className="particle particle-1"></div>
                        <div className="particle particle-2"></div>
                        <div className="particle particle-3"></div>
                        <div className="particle particle-4"></div>
                        <div className="particle particle-5"></div>
                     </div>
                  </div>
               </div>
               <div className="col-lg-6">
                  <div className="ps-lg-4">
                     <span className="sub-title style1 mb-2">Tentang Aplikasi</span>
                     <h2 className="sec-title mb-3 heading">GIS Monitoring Telekomunikasi &amp; WiFi Kabupaten</h2>
                     <p className="mb-3">Aplikasi ini merupakan platform Geographic Information System (GIS) modern untuk memantau, menganalisis, dan mengelola infrastruktur menara telekomunikasi serta lokasi WiFi publik di wilayah kabupaten Anda secara interaktif dan real-time.</p>
                     <ul className="list-unstyled mb-4">
                        <li className="mb-2"><i className="fas fa-map-marked-alt text-primary me-2"></i> Peta interaktif menampilkan posisi menara &amp; WiFi secara detail</li>
                        <li className="mb-2"><i className="fas fa-chart-bar text-success me-2"></i> Statistik real-time jumlah, status aktif, dan distribusi lokasi</li>
                        <li className="mb-2"><i className="fas fa-layer-group text-info me-2"></i> Kontrol layer, filter kecamatan, dan pencarian lokasi</li>
                        <li className="mb-2"><i className="fas fa-mobile-alt text-warning me-2"></i> Akses mudah via desktop &amp; mobile, tampilan modern &amp; responsif</li>
                     </ul>
                     <div className="mb-3">
                        <strong>Visi:</strong> Mendukung pemerataan akses telekomunikasi &amp; internet untuk kemajuan daerah.
                     </div>
                     <div className="mb-4">
                        <strong>Misi:</strong> Menyediakan data infrastruktur yang akurat, transparan, dan mudah diakses oleh pemerintah, operator, dan masyarakat.
                     </div>
                     <Link to="/contact" className="th-btn style3 th-icon">
                        Hubungi Kami
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default AboutFour
